import React from 'react'
import { get } from 'lodash'
import { useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { Redirect, useParams, useLocation } from 'react-router-dom'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import { getVehicleBasePath } from 'lib/utils/store/vehicle'
import { logException } from 'lib/errors'
import { getLocale } from 'lib/utils/getLocale'

import Loading from 'components/Util/Loading'

import getVehicleByAd from 'graphql/vehicle/getVehicleByAd.gql'

export const REDIRECT_AD_ACTIONS = Object.freeze({
    BOS: 'bill-of-sale',
})

const RedirectAd = () => {
    const { vertical, adId, action } = useParams()
    const location = useLocation()
    const { i18n } = useTranslation()

    const { loading, error, data } = useQuery(getVehicleByAd, {
        variables: { vertical, id: adId },
        fetchPolicy: fetchPolicy.NETWORK_ONLY,
    })

    const redirect = (data) => {
        if (error) {
            return <Redirect to={`${getLocale(i18n.language)}/fiksut-kaupat`} />
        }

        const { vehicleByAd: vehicle } = data

        if (!action) {
            return <Redirect to={`${getLocale(i18n.language)}${getVehicleBasePath(vehicle)}`} />
        }

        switch (action) {
        case REDIRECT_AD_ACTIONS.BOS: {
            const bosId = get(vehicle, 'bos.id', null)
            if (bosId) {
                return <Redirect to={`${getLocale(i18n.language)}/fiksut-kaupat/sahkoinen-kauppakirja/${bosId}`} />
            } else {
                return <Redirect to={`${getLocale(i18n.language)}${getVehicleBasePath(vehicle)}/luo-sahkoinen-kauppakirja`} />
            }
        }
        default:
            logException(`Invalid RedirectAd action: "${action}" pathname: "${location.pathname}"`)
        }
    }

    return (
        <Loading loading={loading}>
            {() => redirect(data)}
        </Loading>
    )
}

export default RedirectAd
